import { compareAsc as compareAscInternal, parseISO, format } from "date-fns";
import moment, { Moment } from "moment";
import "moment-timezone";

/** @deprecated use date utilities from our @validereinc/utilities package instead */
export const DATE_FORMATS = {
  FORMAT_CARD_DATE: "MMM Do, YYYY h:mm A",
};

export const DEFAULT_TIMEZONE = "Etc/UTC";

export { format };

/** @deprecated use date utilities from our @validereinc/utilities package instead */
export const TIMEZONE: string = moment.tz.guess()
  ? moment.tz.guess()
  : DEFAULT_TIMEZONE;

/** @deprecated use date utilities from our @validereinc/utilities package instead */
export function getTimeStringFromUTC(utcTime: number, format: string): string {
  if (utcTime) {
    return moment.unix(utcTime).tz(TIMEZONE).format(format);
  }
  return "-";
}

/** @deprecated use date utilities from our @validereinc/utilities package instead */
export function getTimeStringFromDate(
  date: Date | string | Moment,
  format: string
): string {
  if (date) {
    return moment(date).tz(TIMEZONE).format(format);
  }

  return "-";
}

/** @deprecated use date utilities from our @validereinc/utilities package instead */
export function getUTCTimeString(date: Date | string, format: string): string {
  if (date) {
    return moment.utc(date).format(format);
  }

  return "-";
}

/*
The date-fns library introduced an update that caused warnings 
to appear in our storybook adding a lot of extra noise.
By centralizing this function, we can prevent 
it from happening now and in the future.
*/
/** @deprecated */
export function compareAsc(aTime: Date, bTime: Date) {
  return compareAscInternal(
    parseISO(aTime.toString()),
    parseISO(bTime.toString())
  );
}

// accepts either created_at or updated_date depending on your needs
/** @deprecated code smell and needs to be deleted */
export function getAuthorWithDate(
  author = "",
  date: Date = new Date(),
  format: string = DATE_FORMATS.FORMAT_CARD_DATE
) {
  const formattedDate = date ? getTimeStringFromDate(date, format) : "";

  if (author !== "" && formattedDate !== "") {
    return `${author} (${formattedDate})`;
  } else if (author !== "" && formattedDate === "") {
    return author;
  } else if (author === "" && formattedDate !== "") {
    return formattedDate;
  } else {
    return "";
  }
}

// accepts either created_at or updated_date depending on your needs
/** @deprecated code smell and needs to be deleted */
export function getLastUpdate(
  date: Date = new Date(),
  format: string = DATE_FORMATS.FORMAT_CARD_DATE
) {
  const formattedDate = date ? getTimeStringFromDate(date, format) : "";

  if (formattedDate !== "") {
    return `Last Updated: ${formattedDate}`;
  }
  return "";
}

/** @deprecated code smell and needs to be deleted */
export const getValidMinute = (newMinuteStr: string): string => {
  const newMinute = Number(newMinuteStr);

  // we don't support military time
  if (newMinute > 59) {
    return "59";
  } else if (newMinute <= 0) {
    return "00";
  } else if (newMinute < 10 && newMinute > 0) {
    return `0${newMinute}`;
  } else {
    return `${newMinute}`; // 10...59
  }
};

/** @deprecated code smell and needs to be deleted */
export const getValidHour = (newHourStr: string): string => {
  const newHour = Number(newHourStr);

  // we don't support military time
  if (newHour > 12) {
    return "12";
  } else if (newHour <= 0) {
    return "01";
  } else if (newHour < 10 && newHour > 0) {
    return `0${newHour}`;
  } else {
    return `${newHour}`; // 10...12
  }
};
